'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Toast", {
    enumerable: true,
    get: function() {
        return Toast;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useToast = require("./useToast");
const _renderToast = require("./renderToast");
const _useToastStylesstyles = require("./useToastStyles.styles");
const _useToastContextValues = require("./useToastContextValues");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const Toast = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useToast.useToast_unstable)(props, ref);
    (0, _useToastStylesstyles.useToastStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useToastStyles_unstable')(state);
    return (0, _renderToast.renderToast_unstable)(state, (0, _useToastContextValues.useToastContextValues_unstable)(state));
});
Toast.displayName = 'Toast';
